import React, {useEffect, useState} from 'react';
import {useIntl} from "react-intl";
import {RequestVisitorSearchCondition} from "../../../../../modules/vms/dto/RequestVisitorSearchCondition";
import {Grid, Stack,} from "@mui/material";
import FormFieldText from "../../../../../components/FormFieldText";
import SearchButton from "../../../../../components/buttons/SearchButton";
import AddButton from "../../../../../components/buttons/AddButton";
import FormFieldSelect from "../../../../../components/FormFieldSelect";
import {SiteDto} from "../../../../../modules/vms/dto/SiteDto";
import {SiteApi} from "../../../../../modules/vms/api/SiteApi";
import {HttpStatus} from "../../../../../modules/common/enums/HttpStatus";
import {VMSCacheKey} from "../../../../../modules/vms/constants/VMSCacheKey";
import {VisitRequestClassify} from "../../../../../modules/vms/enums/VisitRequestClassify";


export type SearchConditionProps = {
    searchCondition: RequestVisitorSearchCondition;
    onChange: (name: string, value: any) => void;
    onSearch: () => void;
    onSearchReport: () => void;
    onOpenRegisterDialog: () => void;
};

const SearchCondition: React.FC<SearchConditionProps> = (props) => {
    const intl = useIntl();
    // 站点列表
    const [sites, setSites] = useState(new Array<SiteDto>());
    useEffect(() => {
        // fetchSiteList();
    }, []);
    // const fetchSiteList = async () => {
    //     const responseResult = await SiteApi.getSiteList();
    //     if (responseResult.status === HttpStatus.SUCCESS) {
    //         if (responseResult.data.length > 0) {
    //             setSites(responseResult.data);
    //         }
    //     }
    //     // let item = localStorage.getItem(VMSCacheKey.VISIT_REQUEST_SITE_ID);
    //     // if (item) {
    //     //     props.onChange("siteId", item)
    //     // }
    //
    // };
    return (
        <div>

            <Grid container columnSpacing={2} alignItems="center">
                <Grid item xs={2}>
                    <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_NAME"})}
                                   value={props.searchCondition.visitorName}
                                   onChange={(value) => {
                                       props.onChange("visitorName", value)
                                   }}/>
                </Grid>

                <Grid item xs={2}>
                    <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_MOBILE"})}
                                   value={props.searchCondition.visitorMobile}
                                   onChange={(value) => {
                                       props.onChange("visitorMobile", value)
                                   }}/>
                </Grid>
                <Grid item xs={2}>
                    <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_COMPANY"})}
                                   value={props.searchCondition.visitorCompany}
                                   onChange={(value) => {
                                       props.onChange("visitorCompany", value)
                                   }}/>
                </Grid>

                <Grid item xs={2}>
                    <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME"})}
                                   value={props.searchCondition.hostName}
                                   onChange={(value) => {
                                       props.onChange("hostName", value)
                                   }}/>
                </Grid>
                <Grid item xs={2}>
                    <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_STAFF_NUMBER"})}
                                   value={props.searchCondition.hostStaffNumber}
                                   onChange={(value) => {
                                       props.onChange("hostStaffNumber", value)
                                   }}/>
                </Grid>
                <Grid item xs={2}>
                    <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_DEPARTMENT_NAME"})}
                                   value={props.searchCondition.hostDepartmentName}
                                   onChange={(value) => {
                                       props.onChange("hostDepartmentName", value)
                                   }}/>
                </Grid>
                <Grid item xs={2}>
                    <FormFieldSelect label={intl.formatMessage({id: "VMS_VISIT_REQUEST_CLASSIFY"})}
                                     value={props.searchCondition.requestClassify}
                                     onChange={(value) => {
                                         props.onChange("requestClassify", value)
                                     }}
                                     items={VisitRequestClassify.List.map((item) => {
                                         return {label: intl.formatMessage({id: item.label}), value: item.value}
                                     })}/>
                </Grid>
                <Grid item xs={2}>
                    <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_VISIT_CODE"})}
                                   value={props.searchCondition.visitCode}
                                   onChange={(value) => {
                                       props.onChange("visitCode", value)
                                   }}/>
                </Grid>
                <Grid item xs={6}></Grid>
                <Grid item xs={2}>
                    <Stack direction={'row'} spacing={2}>
                        <SearchButton onClick={() => props.onSearch()}/>
                        </Stack>
                </Grid>
            </Grid>
        </div>
    );
};

export default SearchCondition;
